module.exports = __webpack_public_path__ + "img/adameva01.729fb403.svg";